exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-progress-circular{margin:1rem;position:absolute!important;left:37%}.tblClass{border-collapse:collapse}.tblClass tr td,.tblClass tr th{border:1px solid #000;padding:8px 0}.textCenter,.textCenter tr td,.textCenter tr th{text-align:center}table.paySchedule{width:99%;border-collapse:collapse}.paySchedule td{border:1px solid #000;padding:6px}.paySchedule tr.tb-td td{font-weight:700;text-align:center}td.textCenter{text-align:center}td.textRight,tr.textRight td{text-align:right}.paySchedule td.borderNone,.paySchedule tr.borderNone td{border:none!important}.textAlignLeft{text-align:left}#prescriptions_bgImgs{position:absolute;left:35%;background-repeat:no-repeat;background-position:50%;background-size:cover;opacity:.1;top:30%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77d981fc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lending/loanProfile/viewDetail.vue
// module id = 1561
// module chunks = 3